// Hosts that serve a tenant somewhere other than its canonical {tenant}.valeriehealth.com. Neither
// can run the Stytch SDK, so their auth pages go to the canonical tenant and a root-domain cookie
// carries the originating host back to /authenticate.

import { PREVIEW_HOST_PATTERN, PREVIEW_RETURN_COOKIE } from "@/src/lib/preview-env";

export const RETURN_COOKIE_MAX_AGE_SECONDS = 600;

export type AlternateHost = {
  host: string;
  tenant: string;
  cookie: string;
};

/**
 * The alternate host a request arrived on, or null for a canonical host.
 * @param previewHost `x-forwarded-preview-host`, which the preview proxy sets in place of the host.
 */
export function resolveAlternateHost(previewHost: string): AlternateHost | null {
  if (PREVIEW_HOST_PATTERN.test(previewHost)) {
    return { host: previewHost, tenant: previewHost.split("--")[0], cookie: PREVIEW_RETURN_COOKIE };
  }

  return null;
}

/** Whether a browser host is an alternate one, and so not a registered Stytch SDK domain. */
export function isAlternateHost(host: string): boolean {
  return PREVIEW_HOST_PATTERN.test(host);
}

// Return cookies in the order /authenticate prefers them, each with the pattern its value must match.
export const RETURN_HOST_COOKIES = [{ cookie: PREVIEW_RETURN_COOKIE, pattern: PREVIEW_HOST_PATTERN }];
